import { IconProps } from './types';

export const PriceIcon = ({ fill = '#fff', ...props }: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11.979 16.784'>
    <path
      // eslint-disable-next-line max-len
      d='M11.64,16.552a.449.449,0,0,0-.54-.351,7.871,7.871,0,0,1-1.7.2,4.823,4.823,0,0,1-4.55-3.2H9.107a.45.45,0,0,0,.439-.351l.239-1.062a.45.45,0,0,0-.439-.548H4.317a8.088,8.088,0,0,1,.005-1.583H9.814a.45.45,0,0,0,.439-.353L10.5,8.19a.45.45,0,0,0-.439-.546H4.877A4.705,4.705,0,0,1,9.284,4.834a7.338,7.338,0,0,1,1.418.155.45.45,0,0,0,.525-.323L11.675,3a.449.449,0,0,0-.349-.559,10.91,10.91,0,0,0-1.974-.2A8.006,8.006,0,0,0,1.689,7.645H.45a.45.45,0,0,0-.45.45V9.209a.45.45,0,0,0,.45.45h.808a11.122,11.122,0,0,0-.007,1.583H.45a.45.45,0,0,0-.45.45v1.062a.45.45,0,0,0,.45.45H1.578a7.848,7.848,0,0,0,7.775,5.831,9.344,9.344,0,0,0,2.289-.292.45.45,0,0,0,.329-.523l-.33-1.667Z'
      transform='translate(0 -2.25)'
      fill={fill}
      {...props}
    />
  </svg>
);
